import { useMutation, useQueryClient, UseMutationResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";
import { DailyMemoResponse } from "./useGetDailyMemo";

interface DailyMemoRequest {
    memo_date: string;
    contents: string;
}

/*
// 일자별 공유 메모 저장
// 일자당 한 건이라 서버가 있으면 수정, 없으면 생성한다.
*/
export const usePutDailyMemo = (
    successCallback?: () => void,
): UseMutationResult<DailyMemoResponse, Error, DailyMemoRequest> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<DailyMemoResponse, Error, DailyMemoRequest>({
        mutationFn: async ({ memo_date, contents }: DailyMemoRequest) => {
            const response = await axios.put(
                enum_api_uri.daily_memo,
                { memo_date, contents },
                { headers: { Authorization: `Bearer ${accessToken}` } },
            );
            return response.data.data;
        },
        onSuccess: (_data, variables) => {
            // 다른 사람이 그 사이 고쳤을 수 있으므로 저장 후 서버 값을 다시 받는다
            queryClient.invalidateQueries({ queryKey: ["getDailyMemo", variables.memo_date] });
            // 새로 쓰거나 지운 날짜는 달력 점 표시도 달라진다
            queryClient.invalidateQueries({ queryKey: ["getDailyMemoDates"] });
            successCallback?.();
        },
    });
};
